import { call, put } from 'redux-saga/effects';
import ChangePasswordActions from '../redux/ChangePasswordRedux';
import { api } from './api';


export function* changepasswordsagas(action: any): Generator<any, void, any> {
  const { password, old_password } = action;
  
  const response = yield call(api.changePassword, password, old_password);

  // success?
  if (response.ok) {
    yield put(ChangePasswordActions.changePasswordSuccess(response.data));
  } else {
    yield put(ChangePasswordActions.changePasswordFailure(response.data));
  }
}